export default "__VITE_ASSET__D8nG9DWM__"